







import { Component, Vue, Prop } from "vue-property-decorator";
// @ts-ignore
import VClamp from "vue-clamp";

@Component({
    components: {
        VClamp
    }
})
export default class Name extends Vue {
    @Prop({ required: true }) estate!: Estate;

    @Prop({ default: false }) clamp!: boolean;

    @Prop({ default: 2 }) maxLines!: number;

    get smartName() {
        if (!this.estate.name || this.estate.name.length < 5) {
            const purposeId = this.estate.purpose.id;
            const categoryId = this.estate.category.id;
            let purpose = "";
            let type = "";
            if (purposeId === 1) {
                purpose = "te koop";
            }

            if (purposeId === 2) {
                purpose = "te huur";
            }

            if (categoryId === 1) {
                type = "Huis";
            }

            if (categoryId === 2) {
                type = "Appartement";
            }

            if (categoryId === 3) {
                type = "Grond";
            }

            if (categoryId === 4) {
                type = "Kantoor";
            }

            if (categoryId === 5) {
                type = "Commerciëel pand";
            }
            if (categoryId === 6) {
                type = "Industrieel pand";
            }
            if (categoryId === 7) {
                type = "Garage/Parking";
            }

            return `${type} ${purpose} in ${this.estate.city}`;
        }

        return this.estate.name;
    }
}
